import BaseChart from '../baseChart';

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Series Data array for line chart */
//   data: [],
//   /* Set additional options for line chart. */
//   options: {},
//   /* Theme of the line chart. */
//   theme: string,
// };

export default function Line(props) {
  const { className, data, options, ...otherProps } = props;

  return (
    <BaseChart
      className={className}
      chartType="line"
      data={data}
      options={options}
      {...otherProps}
    />
  );
}
